import { TEMPLATE_NAMES } from '@/cms/constants/template-names'
import { AllCMSPageFields } from '@/cms/fields/mappers/common'
import { Configuration } from '@/scopes/common/domain/types/configuration'
import { MetaTitleResolver } from '@/scopes/common/domain/types/meta-data'
import { IntlShape } from 'react-intl'
import { CatalogueType } from '../../../domain/enums/CatalogueType'
import { getCatalogueTypeByPublicationCode } from '../../../domain/functions/catalogues'

interface DestinationMetaTitleResolverDependencies {
  config: Configuration
  cmsFields: AllCMSPageFields
  intl: IntlShape
}

const PAGE_TITLE_TRANSLATION_KEY: Record<string, Record<Exclude<CatalogueType, CatalogueType.None>, string>> = {
  [TEMPLATE_NAMES.CountryPage]: {
    [CatalogueType.Summer]: 'destination_default_page_title_country_summer',
    [CatalogueType.Winter]: 'destination_default_page_title_country_winter',
  },
  [TEMPLATE_NAMES.RegionPage]: {
    [CatalogueType.Summer]: 'destination_default_page_title_region_summer',
    [CatalogueType.Winter]: 'destination_default_page_title_region_winter',
  },
  [TEMPLATE_NAMES.CityPage]: {
    [CatalogueType.Summer]: 'destination_default_page_title_city_summer',
    [CatalogueType.Winter]: 'destination_default_page_title_city_winter',
  },
}

export function createCmsDestinationMetaTitleResolver({ config, cmsFields, intl }: DestinationMetaTitleResolverDependencies): MetaTitleResolver {
  return {
    resolve: () => {
      const catalogueType = getCatalogueTypeByPublicationCode(config.publicationCode)

      if (catalogueType === CatalogueType.None) {
        return config.brandName
      }
      const destinationName = cmsFields['DestinationPage.productName']

      if (!destinationName) {
        return config.brandName
      }

      const translationKey = PAGE_TITLE_TRANSLATION_KEY[cmsFields.template]?.[catalogueType]
      const title = intl.formatMessage(
        { id: translationKey, defaultMessage: '' },
        { destinationName },
      )

      return title || config.brandName
    },
  }
}
